import { render, staticRenderFns } from "./GroupSiteWidget.vue?vue&type=template&id=0f3791cb&scoped=true&"
import script from "./GroupSiteWidget.vue?vue&type=script&lang=js&"
export * from "./GroupSiteWidget.vue?vue&type=script&lang=js&"
import style0 from "./GroupSiteWidget.vue?vue&type=style&index=0&id=0f3791cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3791cb",
  null
  
)

export default component.exports